import React from 'react';

import {RemoveIcon} from 'src/components/remove-icon';

import {Group} from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';


type Props = {
    addedFile: File,
    removeFile: () => void,
    width?: number,
};

export const AddedFile = ({addedFile, removeFile, width = 900}: Props) => {
    return (
        <div style={{width}}>
            <Group direction="v" gap="sm">
                <strong>Uploaded</strong>
                <Group key={addedFile.type} justify="space-between">
                    <Group gap="xls">
                        <Icon type={Icons.FILE}/>
                        <div>{addedFile.name}</div>
                    </Group>
                    <RemoveIcon handler={removeFile}/>
                </Group>
            </Group>
        </div>
    );
};
